import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { formatPrice } from 'services/formatter';

import styles from './DetailsProductsTableFooter.module.scss';

type Props = {
  component?: React.ElementType;
  finalCosts: (string | undefined)[];
  nbColumns: number;
};

export default function DetailsProductsTableFooter({
  component: Component = Fragment,
  finalCosts,
  nbColumns,
}: Props): JSX.Element {
  const { t } = useTranslation(['ordersPage']);
  const [
    subTotalDiscount,
    subTotalOrder,
    FPORT,
    FSIMO,
    FCR,
    FDOUA,
    REM,
    MTT_TOTAL,
    paymentMethod,
    deliveryMethod,
  ] = finalCosts;

  const displayTableFooter = [
    { label: t('LABEL_ORDER_DISCOUNT'), value: subTotalDiscount },
    { label: t('LABEL_ORDER_SUBTOTAL'), value: subTotalOrder },
    { label: t('LABEL_ORDER_FPORT'), value: FPORT },
    { label: t('LABEL_ORDER_FSIMO'), value: FSIMO },
    { label: t('LABEL_ORDER_FCR'), value: FCR },
    { label: t('LABEL_ORDER_FDOUA'), value: FDOUA },
    { label: t('LABEL_ORDER_REM'), value: `-${REM}` },
    { label: t('LABEL_ORDER_TOTAL_ORDER'), value: MTT_TOTAL },
  ];

  const orderMethod = [
    { label: t('LABEL_DELIVERY_BILLING_METHOD'), value: paymentMethod },
  ];

  if (deliveryMethod) {
    orderMethod.push({
      label: t('LABEL_DELIVERY_SHIPPING_METHOD'),
      value:
        deliveryMethod.charAt(0).toUpperCase() +
        deliveryMethod.slice(1).toLowerCase(),
    });
  }

  return (
    <Component>
      {displayTableFooter.map(({ label, value }) => {
        const restNbColumns = nbColumns - 5;

        if (
          (value && parseFloat(value) !== 0) ||
          label == t('LABEL_ORDER_FPORT')
        ) {
          return (
            <tr key={label} className={styles.footerTable}>
              <td className={styles.tdFooter} colSpan={4}>
                {label}
              </td>
              <td className={classNames(styles.tdFooter, styles.value)}>
                {formatPrice(value)}
              </td>
              {restNbColumns > 0 && (
                <td className={styles.tdFooter} colSpan={restNbColumns}></td>
              )}
            </tr>
          );
        }
      })}
      {orderMethod.map(({ label, value }) => {
        const restNbColumns = nbColumns - 6;

        return (
          <tr key={label} className={styles.footerTable}>
            <td className={styles.tdFooter} colSpan={4}>
              {label}
            </td>
            <td
              className={classNames(styles.tdMethod, styles.value)}
              colSpan={2}
            >
              {value}
            </td>
            {restNbColumns > 0 && (
              <td className={styles.tdFooter} colSpan={restNbColumns}></td>
            )}
          </tr>
        );
      })}
    </Component>
  );
}
